/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector, batch } from 'react-redux';
import { DATA_MIGRATION_PROGRESS } from 'utils/consts/migration';
import { setMigrationStatus } from 'state/slices/migration';
import { updateMigrationStatus } from 'state/thunks/migration';
// utils
// material
import { Button, displayModal, log } from '@insticator/insticator-ui';
import Space from 'material/space/space'
// content
// styles
import injectSheet from "react-jss";
import styles from './migratedata_styles';


/* ========== ~~~~~~~~~~ COMMENTING 2.0 ACTIVATED ~~~~~~~~~~ ========== */
const MigrateData = injectSheet(styles)((props) => {
  const dispatch = useDispatch();
  const { siteUUID } = useSelector(state => state.session);
  const { migrationStatus, isMigrationUpdating } = useSelector(state => state.migrationStatus)
  const adminEmail = useSelector(state => state.session.userEmail);

  const startMigration = useCallback(async () => {
    const response = await dispatch(updateMigrationStatus({
      siteId: siteUUID,
      data: {
        currentStatus: migrationStatus,
        adminEmail
      }
    }))
    log('response', response)
    if(response.payload) dispatch(displayModal(false))
  },[dispatch])

  return (
    <Space direction={'column'} alignItems={'center'} justifyContent={'center'}>
      <h4>Migrate Data to Commenting 2.0</h4>
      <Space direction={'column'} alignItems={'flex-start'} justifyContent={'flex-start'} gap={16} style={{textAlign: 'left',}}>
        <p>This will kick off a process that ports all of the existing comment and user data for this site into the new system.</p>
        <Space gap={0} direction={'column'}>
          <p><strong className='errormessage'>IMPORTANT:</strong></p>
          <ul>
            <li>Make sure the new code is live on the production site first</li>
            <li>Commenting configurations will be disabled until this migration process is complete</li>
            <li>We can only migrate one site at a time</li>
          </ul>
        </Space>
        <p><strong>The amount of time needed to migrate data depends on several factors; we will inform you when the process is complete.</strong></p>
      </Space>
      <Space style={{marginTop: '32px'}} alignItems={'center'} justifyContent={'center'}>
        <Button 
          text={'Start Data Migration'} 
          variant={'primary'} 
          processing={isMigrationUpdating} 
          processingText={'Starting Migration..'}
          handleClick={() => startMigration()} 
        />
      </Space>   
    </Space>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default MigrateData